'use strict';

module.exports = function () {
    var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    var SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;
    var SpeechRecognitionEvent = window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;

    var recognition = new SpeechRecognition();
    // if (SpeechGrammarList) {
    //   // SpeechGrammarList is not currently available in Safari, and does not have any effect in any other browser.
    //   // This code is provided as a demonstration of possible capability. You may choose not to use it.
    //   var speechRecognitionList = new SpeechGrammarList();
    //   var grammar = '#JSGF V1.0; grammar colors; public <color> = ' + colors.join(' | ') + ' ;'
    //   speechRecognitionList.addFromString(grammar, 1);
    //   recognition.grammars = speechRecognitionList;
    // }
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    // var diagnostic = document.querySelector('.output');
    // var bg = document.querySelector('html');
    // var hints = document.querySelector('.hints');

    // var colorHTML = '';
    // colors.forEach(function (v, i, a) {
    //   console.log(v, i);
    //   colorHTML += '<span style="background-color:' + v + ';"> ' + v + ' </span>';
    // });
    // hints.innerHTML = 'Tap/click then say a color to change the background color of the app. Try ' + colorHTML + '.';

    var animationActive = false;
    var micBlocked = false;
    var safariStopTimer = null;
    var recognitionActive = false;

    function getPlaceholders() {
        return {
            defaultPlaceholder: $('.search-default-placeholder font font').text() || $('.search-default-placeholder').text(),
            listeningPlaceholder: $('.search-listening-placeholder font font').text() || $('.search-listening-placeholder').text()
        };
    }

    $('.voice-search-button').on('click', function (e) {
        e.preventDefault();

        var placeholders = getPlaceholders();
        recognition.lang = 'en-US';

        if (animationActive) {
            if (!micBlocked) {
                $(this).removeClass('fa-spin');
                animationActive = false;
                return;
            }

            $(this).removeClass('fa-spin listening');
            $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
            animationActive = false;
            forceStopRecognition();
            return;
        }

        $(this).addClass('fa-spin');
        animationActive = true;
        micBlocked = false;

        if (!$(this).hasClass('listening')) {
            try {
                $('.search-field').val('').attr('placeholder', placeholders.listeningPlaceholder);
                recognition.stop();
                recognition.lang = 'en-US';
                recognition.start();
                $(this).addClass('listening');

                recognitionActive = true;

                clearTimeout(safariStopTimer);
                safariStopTimer = setTimeout(function () {
                    if (recognitionActive) {
                        forceStopRecognition();
                    }
                }, 9000);

            } catch (err) {
                if (err.name === 'InvalidStateError') {
                    recognition.stop();
                    recognition.lang = 'en-US';
                    setTimeout(() => recognition.start(), 50);
                }
            }
        }
    });

    recognition.onstart = function () {
        if (!micBlocked) {
            var placeholders = getPlaceholders();
            $('.search-field').attr('placeholder', placeholders.listeningPlaceholder);
        }
    };

    recognition.onresult = function (event) {
        var q = event.results[0][0].transcript.toLowerCase();
        q = q.replace(/[.,!?]+$/, '');
        $('.site-search .search-field').val('“' + q + '”');
        setTimeout(function () {
            $('form[name="simpleSearch"]').submit();
            forceStopRecognition();
        }, 50);
    };

    recognition.onspeechend = function () {
        forceStopRecognition();
    };

    recognition.onnomatch = function () {
        var placeholders = getPlaceholders();
        $('.voice-search-button').removeClass('fa-spin listening');
        $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
        animationActive = false;
        recognitionActive = false;
        clearTimeout(safariStopTimer);
    };

    recognition.onerror = function (event) {
        var placeholders = getPlaceholders();
        if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
            micBlocked = true;
            setTimeout(function () {
                $('.voice-search-button').removeClass('fa-spin listening');
                $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
                animationActive = false;
                recognitionActive = false;
            }, 6000);
        } else {
            $('.voice-search-button').removeClass('fa-spin listening');
            $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
            animationActive = false;
            recognitionActive = false;
        }
        clearTimeout(safariStopTimer);
    };

    recognition.onend = function () {
        if (micBlocked) return;
        var placeholders = getPlaceholders();
        $('.voice-search-button').removeClass('fa-spin listening');
        $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
        animationActive = false;
        recognitionActive = false;
        clearTimeout(safariStopTimer);
    };

    /**
     * Helper to stop recognition in Safari reliably
     */
    function forceStopRecognition() {
        try {
            recognition.stop();
            setTimeout(() => recognition.stop(), 100);
        } catch (e) {}
        var placeholders = getPlaceholders();
        $('.voice-search-button').removeClass('fa-spin listening');
        $('.search-field').attr('placeholder', placeholders.defaultPlaceholder);
        animationActive = false;
        recognitionActive = false;
        clearTimeout(safariStopTimer);
    }
};
